<template>
  <Gallery
    v-if="loaded"
    :id="store.item.id.split('/Product/')[1]"
    :title="store.item.title"
    :variant="store.selected.variant"
    :short-description="shortDescription"
    :gallery="store.gallery"
    :option="store.selected.gallery"
  />
  <Form v-if="loaded" :location="Location.PDP" :bnpl-message="bnplMessage" />
  <ShopTheLookNavigation v-if="shopTheLookEnabled" :terms="terms" />
</template>

<script setup>
import { matchesSchema } from '@utils/performance';
import * as Sentry from '@sentry/vue';
import { Location } from '../Global/Location.types';
import { computed, onMounted, ref } from 'vue';
import { useProductStore } from './Composables/Store';

import Gallery from './Gallery.vue';
import Form from './Form.vue';
import ShopTheLookNavigation from './ShopTheLookNavigation.vue';

const props = defineProps({
  terms: { type: Object, required: true, default: () => ({}) },
  handle: { type: String, required: true, default: '' },
  variant: { type: [String, Number], required: false, default: '' },
  settings: { type: Object, required: true, default: () => ({}) },
  bnplMessage: { type: String, default: '' },
  secondaryProducts: { type: Array, required: false, default: () => [] },
  secondaryProductsLabels: { type: Array, required: false, default: () => [] },
  secondaryProductsLimits: { type: Array, required: false, default: () => [] },
  freeShippingTerms: {
    type: Object,
    default: () => ({
      banner_title: '',
      banner_copy: '',
    }),
    validator: matchesSchema({
      banner_title: 'string',
      banner_copy: 'string',
    }),
  },
});

const shortDescription = computed(() => {
  return store?.item?.shortDescription?.value ?? '';
});

const loaded = ref(false);
const handle = props?.handle?.substring(1);
const store = useProductStore();
store.mountPromoListener();

const shopTheLookEnabled = computed(() => store.shopTheLookEnabled);

onMounted(async () => {
  Sentry.addIntegration(
    Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false })
  );
  try {
    store.$state.terms = props.terms;
    store.$state.settings = props.settings;
    store.$state.freeShippingTerms = props.freeShippingTerms;
    store.$state.gallery = await store.fetchGallery(handle);
    store.$state.item = await store.fetchProduct(handle);
    store.$state.upsell.items = [];
    if (store.$state.item?.upsell_products) {
      store.$state.upsell.items =
        store.$state.item?.upsell_products?.value.split('|') ?? [];
    }
    await store.setSecondaryProducts(props);
    await store.setInititalState(props);
    loaded.value = true;
  } catch (err) {
    Sentry.captureException(err);
    return err;
  }
});
</script>
